@if (model) {
    <form [formGroup]="model">
        @if(form.uploadButton) {
            <app-reactive-upload-images [formModel]="model.getRawValue()" [imageFolder]="form.name" [formType]="form.type"
                [imageDisplay]="'inline'" [imageName]="'imagen'" (sendImageName)="updateImageModel($event, 'imagen')">
            </app-reactive-upload-images>
        }
        <div class="row flex-wrap">
            <!-- FORM FIELDS -->
            @for (section of form.sections; track section) {

                @if (section.isVisible) {
                    <div class="d-flex flex-column flex-md-row gap-5 align-items-end">
                        <div class="col-sm-{{ section.width }} mb-3">
                            <div class="row">
                                <div class="col col-md-2">
                                    <h4>{{ section.name }}</h4>
                                </div>
                                @for (button of section.buttons; track $index) {
                                    <div class="col col-md-1">
                                        <button *ngIf="button.isVisible" [class]="button.class" [style]="button.style"
                                            (click)="button.function()">
                                            <i [class]="button.icon" aria-hidden="true"></i>
                                            <span>{{button.label}}</span>
                                        </button>
                                    </div>
                                }
                            </div>
                            <div class="row align-items-end">

                                @for (field of section.fields; track field) {

                                    @if (field.conditions.isVisible) {
                                        <div class="col-sm-{{ field.width }} mb-3">
                                            <app-field [form]="form" [field]="field" [model]="model" [undoEnabled]="undoEnabled"
                                                [originalModel]="originalModel" [filterInputParcelas]="filterInputParcelas">
                                            </app-field>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col d-flex flex-column gap-5 w-100 overflow-x-scroll  ">
                            @if (section.tables !== null && this.form.type < 3) {
                                @for (table of section.tables; track table) {

                                @if (table.title) {
                                    <h2 class="fert-table-title">{{ table.title }}</h2>
                                }

                                <table class="table-style">
                                    @for (row of table.data; track row; let rowNumber = $index) {
                                    <tr
                                        [style.background]="table.style?.[rowNumber]"
                                        [style.color]="table.style?.[rowNumber] === '#222222' ? 'white' : 'black'"
                                    >
                                        @for (column of row; track column; let colNumber = $index) {
                                        @if (rowNumber === 0) {
                                            @if (colNumber === 0 && table.showIndex !== false) {
                                            <th style="width: 15px; border: none"></th>
                                            }
                                            <th>{{ column }}</th>
                                        } @else {
                                            @if (colNumber === 0 && table.showIndex !== false) {
                                            <td style="border: none; background: #f8f9fa !important; color: black !important;">
                                                {{ rowNumber }}
                                            </td>
                                            }
                                            <td>{{ column }}</td>
                                        }
                                        }
                                    </tr>
                                    }
                                </table>
                                }
                            }
                            </div>
                    </div>
                    }
                }

                <!-- TABLE -->
                @if (form.table !== null) {
                    <div class="d-flex justify-content-center">
                        <table class="table-style">
                            @for (row of form.table.data; track row; let rowNumber = $index) {
                                <tr [style.background]="form.table.style?.[rowNumber]"
                                    [style.color]="form.table.style?.[rowNumber] === '#222222' ? 'white' : 'black'">

                                    @for (column of row; track column; let colNumber = $index) {
                                        @if (rowNumber === 0) {

                                            @if (colNumber === 0) {
                                                <th style="width: 15px; border: none"></th>
                                            }

                                            <th>{{column}}</th>
                                        } @else {

                                            @if (colNumber === 0) {
                                                <td style="border: none; background: #f8f9fa !important; color: black !important;">{{rowNumber}}
                                            </td>
                                        }

                                            <td>{{column}}</td>
                                        }
                                    }
                                </tr>
                            }
                        </table>
                    </div>
                }

                <br>

                <!-- SIGNATURE -->
                @if (form.signed) {

                    @if (model.get('signature_img')?.value){
                        <div class="distribution_camera_signature" style="display: flex; gap: 50px; align-items: center;">
                            <div>
                                <div style="display: flex; flex-direction: column;">
                                    <p>Firma</p>

                                    @if (!model.get('signature_img')?.value.includes('base64')) {
                                        <img alt="Firma" [src]="serverUrl + 
                                                                'images/fitosanitarios/' + 
                                                                model.get('signature_img')?.value" class="info-firma-img">
                                    } @else {
                                        <img alt="Firma" [src]="model.get('signature_img')?.value" class="info-firma-img">
                                    }
                                </div>
                            </div>
                        </div>

                    }

                    @if(form.type < 3) { 
                        <app-signature (sendFile)="getSignature($event)" (sendTempImg)="updateFirma($event);">
                        </app-signature>
                    }
                }

                <!-- ACTION BUTTONS -->
                @if(form.type <= 4 && showActionsButtons) { <div class="d-flex justify-content-center mt-4">
                    <div>
                        <button class="btn btn-dark mx-2" (click)="form.type < 3 ? returnToMainView() : closeDialog()">
                            {{ form.type < 3 ? 'Volver' : 'Cerrar' }} </button>
                    </div>

                    @if (form.type <= 3) { <app-reactive-request-button [form]="form" [model]="model"
                        [recordHasAssociatedData]="recordHasAssociatedData" [request]="request" [getRequest]="getRequest"
                        [lockOnSuccess]="true" (goBack)="returnToMainView()"
                        (afterSend)="executePostSubmissionLogic($event)">
                        </app-reactive-request-button>
                    }
            </div>
        }
        </div>
    </form>
}